import React, { Component, Fragment } from "react";
import { TextField } from "@material-ui/core";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactTooltip from "react-tooltip";

var fieldTypes = require("./fieldEnums").default;
var txtMaxLength = 38;
var dateMaxLength = 25;

class SingleQuestion extends Component {
  render() {
    var question = this.props.question;
    var val = this.props.val ? this.props.val : "";
    if (question.type === "numberWithCommas") val = this.numberWithCommas(val);
    if (question.type === "date") val = this.reformatDateFormatForUI(val);
    if (question.type === "checkbox" || question.type === "radio") {
      // question.isFieldConnector && question.isFieldConnector === "1" &&
      if (typeof question.options[0] === "string") {
        // this will happen only one time per field on init.
        if (question.type === "checkbox") val = val.split(";:;");
        question.options = question.options.map((item) => {
          var optsArr = item.split("|");
          return { key: optsArr[0], label: optsArr[1] };
        });
      }
    } else if (question.type === "radioValues") {
      if (typeof question.options[0] === "string") {
        question.options = question.options.map((item) => {
          var optsArr = item.split("|");
          return { key: optsArr[0], label: optsArr[1] };
        });
      }
    }

    var chooseCorrectMaxLength = question.type === "date" ? dateMaxLength : txtMaxLength;
    if (question.optionsTitle && question.optionsTitle.length > chooseCorrectMaxLength && !question.fullLabel) {
      question.fullLabel = question.optionsTitle;
      // question.optionsTitle = question.optionsTitle.substring(0, chooseCorrectMaxLength) + "...";
    } else if (question.label && question.label.length > chooseCorrectMaxLength && !question.fullLabel) {
      question.fullLabel = question.label;
      question.label = question.label.substring(0, chooseCorrectMaxLength) + "...";
    }

    var renderedUI = this.getRenderedUI(question, val);
    return (
      <Fragment>
        {renderedUI}
        <ReactTooltip effect="solid" type="warning" />
      </Fragment>
    );
  }

  handleCheckboxChange = (e, panelIndex) => {
    this.props.handleCheckboxChange(e.target.name, e.target.value, e.target.checked, panelIndex);
  };

  handleDateChange = (e, key, panelIndex) => {
    var getDate = e.target.value;
    getDate = getDate.split("-");
    getDate = `${getDate[2]}/${getDate[1]}/${getDate[0]}`;
    getDate = { target: { value: getDate } };
    this.props.handleFieldChange(getDate, key, panelIndex);
  };

  validateNum = (e) => {
    var value = e.target.value.replace(/,/g, "");
    if (isNaN(value)) return;
    value = { target: { value } };
    this.props.handleFieldChange(value, e.target.id, this.props.panelIndex);
  };

  numberWithCommas = function (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  reformatDateFormatForUI = function (x) {
    x = x.split("/");
    return `${x[2]}-${x[1]}-${x[0]}`;
  };

  getRenderedUI = function (question, val) {
    switch (question.type) {
      case fieldTypes.txt:
        return this.getTxt(question, val);
      case fieldTypes.date:
        return this.getDate(question, val);
      case fieldTypes.number:
        return this.getNumber(question, val);
      case fieldTypes.numberWithCommas:
        return this.getNumberWithCommas(question, val);
      case fieldTypes.selectRange:
        return this.getSelectRange(question, val);
      case fieldTypes.selectOptions:
        return this.getselectOptions(question, val);
      case fieldTypes.textarea:
        return this.getTextarea(question, val);
      case fieldTypes.checkbox:
        return this.getCheckbox(question, val);
      case fieldTypes.radio:
        return this.getRadio(question, val);
      case fieldTypes.longList:
        return this.getLongList(question, val);
      case fieldTypes.radioValues:
        return this.getRadioValues(question, val);

      default:
        return <div></div>;
    }
  };

  getTxt = function (question, val) {
    return (
      <div data-tip={question.fullLabel || null} className="questionnaire-field-wrapper">
        <div>
          <TextField
            id={question.key}
            label={question.label}
            variant="outlined"
            value={val}
            onChange={(e) => {
              this.props.handleFieldChange(e, question.key, this.props.panelIndex);
            }}
            onFocus={(e) => {
              this.props.handleFirstInteractionWithEle(question.infoKey, question.info);
            }}
          />
        </div>
      </div>
    );
  };

  getDate = function (question, val) {
    return (
      <div className="questionnaire-field-wrapper relative" data-tip={question.fullLabel || null}>
        <div className="date-title">
          <span>{question.label}</span>
        </div>
        <input
          id={question.key}
          onChange={(e) => {
            this.handleDateChange(e, question.key, this.props.panelIndex);
          }}
          onFocus={(e) => {
            this.props.handleFirstInteractionWithEle(question.infoKey, question.info);
          }}
          className="date-field padding13"
          type="date"
          value={val}
        />
      </div>
    );
  };

  getNumber = function (question, val) {
    return (
      <div data-tip={question.fullLabel || null} className="questionnaire-field-wrapper">
        <div>
          <TextField
            id={question.key}
            label={question.label}
            variant="outlined"
            value={val}
            onChange={this.validateNum}
            onFocus={(e) => {
              this.props.handleFirstInteractionWithEle(question.infoKey, question.info);
            }}
          />
        </div>
      </div>
    );
  };

  getNumberWithCommas = function (question, val) {
    return (
      <div data-tip={question.fullLabel || null} className="questionnaire-field-wrapper">
        <div>
          <TextField
            id={question.key}
            label={question.label}
            variant="outlined"
            value={val}
            onChange={this.validateNum}
            onFocus={(e) => {
              this.props.handleFirstInteractionWithEle(question.infoKey, question.info);
            }}
          />
        </div>
      </div>
    );
  };

  getSelectRange = function (question, val) {
    return (
      <div>
        <FormControl
          onFocus={(e) => {
            this.props.handleFirstInteractionWithEle(question.infoKey, question.info);
          }}
          className="ml-20 mr-20"
        >
          <InputLabel className="align-select-label" id={question.key}>
            {question.label}
          </InputLabel>
          <Select
            id={question.key}
            className="select-field"
            value={val}
            onChange={(e) => {
              this.props.handleFieldChange(e, question.key, this.props.panelIndex);
            }}
            displayEmpty
          >
            {Array.from(Array(question.endRange - question.startRange).keys()).map((item) => {
              item = item + question.startRange;
              return (
                <MenuItem key={item + question.key} value={item}>
                  {item}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </div>
    );
  };

  getselectOptions = function (question, val) {
    return (
      <FormControl
        onFocus={(e) => {
          this.props.handleFirstInteractionWithEle(question.infoKey, question.info);
        }}
        className="ml-20 mr-20"
      >
        <InputLabel className="align-select-label" id={question.key}>
          {question.label}
        </InputLabel>
        <Select
          id={question.key}
          className="select-field"
          value={val}
          onChange={(e) => {
            this.props.handleFieldChange(e, question.key, this.props.panelIndex);
          }}
          displayEmpty
        >
          {question.options.map((item) => {
            return (
              <MenuItem key={item} value={item}>
                {item}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    );
  };

  getTextarea = function (question, val) {
    return (
      <div className="full-line questionnaire-field-wrapper">
        <span className="primary-color">{question.label}:</span>
        <br />
        <textarea
          id={question.key}
          value={val}
          onChange={(e) => {
            this.props.handleFieldChange(e, null, this.props.panelIndex);
          }}
          onFocus={(e) => {
            this.props.handleFirstInteractionWithEle(question.infoKey, question.info);
          }}
          className="textarea-field"
        ></textarea>
      </div>
    );
  };

  getCheckbox = function (question, val) {
    // option.key comes if the 'question' is connected with more than one field({key:hasDog:"כלב", hasCat:"חתול"}) or it will be just ["חתול","כלב"] for not connected question
    return (
      <div className="full-line-bordered questionnaire-field-wrapper">
        <span className="primary-color">{question.optionsTitle || question.label}</span>
        {question.options.map((option, index) => {
          return (
            <FormControlLabel
              key={option.key || option}
              className="align-checkbox-opts"
              control={<Checkbox value={option.key || option} color="primary" />}
              label={option.label || option}
              onChange={(e) => {
                this.handleCheckboxChange(e, this.props.panelIndex);
              }}
              onFocus={(e) => {
                this.props.handleFirstInteractionWithEle(question.infoKey, question.info);
              }}
              checked={val.includes(option.key || option)}
              name={question.optionsKey || question.key}
            />
          );
        })}
      </div>
    );
  };

  getRadio = function (question, val) {
    return (
      <div className="full-line-bordered questionnaire-field-wrapper">
        <span className="primary-color label-radio-title">{question.optionsTitle || question.label}</span>
        <br />
        <RadioGroup
          name={question.optionsKey}
          value={val}
          className="flex-direction-row"
          onChange={(e) => {
            this.props.handleFieldChange(e, question.optionsKey || question.key, this.props.panelIndex);
          }}
          onFocus={(e) => {
            this.props.handleFirstInteractionWithEle(question.infoKey, question.info);
          }}
        >
          {question.options.map((option, index) => {
            return (
              <FormControlLabel
                key={option.key || option}
                value={option.key || option}
                control={<Radio />}
                label={option.label || option}
              />
            );
          })}
        </RadioGroup>
      </div>
    );
  };

  getLongList = function (question, val) {
    var listData = require("../../assets/data/" + question.longListName).default;
    return (
      <div className="questionnaire-field-wrapper">
        <Autocomplete
          // id={dna.title + suffix2}
          className="date-field custom-autocomplete"
          options={listData}
          value={val}
          blurOnSelect
          openOnFocus
          renderInput={(params) => <TextField {...params} variant="outlined" label={question.label} />}
          onChange={(event, newValue) => {
            this.props.handleFieldChange({ target: { value: newValue } }, question.key, this.props.panelIndex);
          }}
        />
      </div>
    );
  };

  getRadioValues = function (question, val) {
    return (
      <div className="full-line-bordered questionnaire-field-wrapper">
        <span className="primary-color label-radio-title">{question.label}</span>
        <br />
        <RadioGroup
          name={question.key}
          value={val}
          className="flex-direction-row"
          onChange={(e) => {
            this.props.handleFieldChange(e, question.key, this.props.panelIndex);
          }}
          onFocus={(e) => {
            this.props.handleFirstInteractionWithEle(question.infoKey, question.info);
          }}
        >
          {question.options.map((option, index) => {
            return <FormControlLabel key={option.key} value={option.key} control={<Radio />} label={option.label} />;
          })}
        </RadioGroup>
      </div>
    );
  };
}

export default SingleQuestion;
